import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';


import Label from "../../common/primitives/Label";

import helpers from "../../common/scss/helpers/_helpers.scss";
import buttons from "../../common/primitives/Button.scss";
import removeImg from './img/remove.png';
import styles from "./CartLines.scss";
import Price, {ConvertToEUR} from "../../common/primitives/Price";
import LoadingRow from "../../common/primitives/LoadingRow";
import Tooltip from "../../common/primitives/Tooltip";
import TextBox from "../../common/primitives/TextBox";
import Button from "../../common/primitives/Button";
import {__t} from "../../common/lang/text-resource";

const CartLineGDPRProtect = ({
								 data,
								 removeService,
								 showAsPage,
								 childServices,
								 setDomainName,
								 serviceDomainNameError
							 }) => {
	let {
		id,
		serviceName,
		serviceType,
		serviceTypeName,
		serviceId,
		discountPriceList,
		discountPromo,
		discountTerm,
		term,
		oldPrice,
		price,
		priceTopOrig,
		priceOrig,
		currency,
		isNewService,
		isRenewService,
		canDelete,
		loading,
		serviceNameOrig,
		cartItemName,
		accountName
	} = data;

	const [showInputField, setShowInputField] = useState(serviceNameOrig === cartItemName);
	useEffect(() => {
		setShowInputField(serviceNameOrig === cartItemName);
	}, [cartItemName]);

	if (loading) {
		return (
		  <section className={showAsPage ? styles.asPage : ''}>
			  <div
				data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
				  <div data-layout='col 12 text-center'>
					  <div className={styles.loadingContainer}>
						  <LoadingRow/>
					  </div>
				  </div>
			  </div>
		  </section>
		)
	}

	const showSecondRow = (discountPriceList > 0 || discountPromo > 0 || discountTerm > 0);
	if (serviceType === 'SpamExpert' || serviceType === 'ID_PROTECT' || serviceType === 'WPSupport') {
		serviceName = `${serviceTypeName} (${serviceName})`;
	}
	return (
	  <section className={showAsPage ? styles.asPage : ''}>
		  <div data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
			  <div
				className={styles.removeContainer}
				data-layout={`padding-top--xxs ${!showAsPage ? 'padding-left--xs col 1' : ''}`}>
				  {
					canDelete === true &&
					<button data-layout={!showAsPage ? 'margin-left--xxs' : ''}
							className={`${buttons.buttonImage} ${styles.removeButton}`}
							onClick={() => removeService(id, serviceId, serviceName)}>
						<img src={removeImg} alt="Remove"/>
					</button>
				  }

			  </div>
			  <div data-layout={`col 11 text-left padding-left--xs ${showAsPage ? '5@md' : ''}`}>
				  <Label
					htmlFor={id}
					text={serviceName}
					title={serviceName}
					className={`${helpers.orderServiceName} ${!showAsPage ? styles.asPageServiceName : ''}`}/>
			  </div>
			  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
			  <div data-layout={`col 11 margin-top--xs padding-left--xs  ${showAsPage ? '6@md' : ''}`}>
				  <table className={styles.selectedPriceContainer}>
					  <tbody>
					  <tr>
						  <td>{term}</td>
						  <td className={styles.oldPrice}>
							  {
								  priceOrig !== priceTopOrig ? priceTopOrig : null
							  }
							  {SHVO.showEuroPrices && <>
								  <br/>
								  {
									  priceOrig !== priceTopOrig ? ConvertToEUR(priceTopOrig) : null
								  }
							  </>}
						  </td>
						  <td>
							  <Price
								currency={currency}
								value={priceOrig}
								currencyClass={styles.currency}/>
							  {SHVO.showEuroPrices && <>
								  <br/>
								  <Price
									currency={'EUR'}
									value={ConvertToEUR(priceOrig)}
									currencyClass={styles.currency}/>
							  </>}
						  </td>
						  <td data-layout='padding-right--md'>&nbsp;</td>
					  </tr>
					  </tbody>
				  </table>
			  </div>
		  </div>

		  {
			  showSecondRow ?
				<div data-layout="row gutter-none start" className={styles.discountsWrapper}>
					{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					{/*Редове с отстъпки начало*/}
					{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					<div className={styles.rightAtTabPage} data-layout={`col 12 ${showAsPage ? '6@md' : ''}`}>

						{
							(discountPriceList > 0 && discountPromo < 100) ?
							  <div data-layout="row gutter-none middle">
								  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
								  <div
									data-layout="col 11 margin-top--xs  padding-left--xs text-left"
									className={helpers.orderServiceDiscount}>
									  –{discountPriceList}% {__t('допълнителна партньорска отстъпка *')}
								  </div>
							  </div>
							  : ''
						}

						{
							(discountPromo > 0) ?
							  <div data-layout="row gutter-none middle">
								  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
								  <div
									data-layout="col 11 margin-top--xs  padding-left--xs text-left"
									className={helpers.orderServiceDiscount}>
									  –{discountPromo}% {__t('отстъпка от промокод')}
								  </div>
							  </div>
							  : ''
						}

						{
							(discountTerm > 0 && discountPromo < 100) ?
							  <div data-layout="row gutter-none middle">
								  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
								  <div
									data-layout="col 11 margin-top--xs  padding-left--xs text-left"
									className={helpers.orderServiceDiscount}>
									  –{discountTerm}% {isRenewService ? __t('промоционална отстъпка') : __t('отстъпка за нова услуга')}
								  </div>
							  </div>
							  : ''
						}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*Редове с отстъпки край*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					</div>
					{
						showAsPage ? <div className={styles.removeContainer} data-layout="first@md"/> : ''
					}
					<div data-layout={`col 12 ${showAsPage ? '5@md first@md' : ''}`}>
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*Основен домейн начало*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						<div data-layout="row gutter-none middle margin-top--xxs">
							<div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
							<div
							  data-layout="col 11 margin-top--xs padding-left--xs text-left">
								{
								  isNewService && cartItemName !== serviceNameOrig &&
								  <React.Fragment>
									  {__t('За')}: <Button
									className={`${buttons.buttonLink} ${buttons.action}`}
									onClick={() => setShowInputField(true)}
									value={cartItemName}/>
								  </React.Fragment>
								}
								{
									isRenewService ? __t('За') + ': ' + accountName : ''
								}
							</div>
						</div>
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*Основен домейн край*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}

					</div>
				</div>
				: ''
		  }
		  {
			showInputField && isNewService &&
			<DomainName
			  domainName={cartItemName === serviceNameOrig ? '' : cartItemName}
			  setDomainName={setDomainName}
			  showError={!!serviceDomainNameError}
			  lineId={id}/>
		  }

		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*Дъщерни услуги начало*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {
			  (childServices) ?
				childServices.map((child, i) => {
					return (
					  <div key={i} data-layout="row gutter-none middle margin-top--xxs">
						  <div className={styles.removeContainer}
							   data-layout={!showAsPage ? 'padding-left--xs col 1' : ''}/>
						  <div
							className={styles.childServiceContainer}
							data-layout={`col 11 margin-top--smm padding-left--xs text-left ${showAsPage ? '5@md' : ''}`}>
							  <table>
								  <tbody>
								  <tr>
									  <td data-layout="text-left">
										  {
											  (child.serviceType !== 'CpanelLicensing' && (child.serviceType === 'BACKUP_SPACE' && child.quantity > 1)) ?
												`${child.quantity} ` : null
										  }

										  {(child.serviceType === 'RAM_VPS') ? 'MB ' :
											(child.serviceType === 'BACKUP_SPACE' && child.quantity > 1) ? 'GB ' :
											  (child.serviceType === 'IPADDRESS' && child.isRenewService !== true) ? (child.quantity === 1) ? 'брой ' : 'броя ' : ''}

										  {child.serviceType === 'SpamExpert' || child.serviceType === 'WPSupport' ?
											<span title={child.serviceTypeName}>{child.serviceTypeName}</span> :
											<span title={child.serviceName}>{child.serviceName}</span>}
									  </td>
								  </tr>
								  </tbody>
							  </table>
						  </div>
						  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
						  <div
							className={styles.childServiceContainerPrice}
							data-layout={`col 11 margin-top--xs padding-left--xs text-left ${showAsPage ? '6@md' : ''}`}>
							  <table>
								  <tbody>
								  <tr>
									  <td>
										  {term}
									  </td>
									  <td className={styles.oldPrice}>
										  {
											  child.priceOrig !== child.priceTopOrig ? child.priceTopOrig : null
										  }
										  {SHVO.showEuroPrices && <>
											  <br/>
											  {
												  child.priceOrig !== child.priceTopOrig ? ConvertToEUR(child.priceTopOrig) : null
											  }
										  </>}
									  </td>
									  <td>

										  <Price
											currency={child.currency}
											value={child.price}/>
										  {SHVO.showEuroPrices && <>
											  <br/>
											  <Price
												currency={'EUR'}
												value={ConvertToEUR(child.price)}/>
										  </>}
									  </td>
								  </tr>
								  </tbody>
							  </table>
						  </div>

						  {
							  (child.percentOff > 0) ?
								<div data-layout="col 12">
									<div data-layout="row gutter-none middle" className={styles.vpsDiscounts}>
										<div
										  data-layout="col 11 offset-1 margin-top--xs padding-left--xs text-left margin-right--20"
										  className={helpers.orderServiceDiscount}>
											–{child.percentOff}% {__t('отстъпка')}
										</div>
									</div>
								</div>
								: ''
						  }
					  </div>
					)
				})

				: undefined
		  }
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*Дъщерни услуги край*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
	  </section>
	);

};


const DomainName = ({domainName, lineId, setDomainName, showError}) => {

	const [value, setValue] = useState(domainName);

	return (
	  <div data-layout="row gutter-none middle margin-top--xxs"
		   className={`${styles.sslDomainNameContainer} ${domainName === '' ? styles.withoutDomainName : ''}`}>
		  <div className={styles.removeContainer} data-layout='col 1 margin-top--sm'>

		  </div>
		  <div
			className={styles.childServiceContainer}
			data-layout={`col 11 margin-top--smm padding-left--xs text-left`}>
			  <p>{__t('Укажете домейн за услугата:')}</p>
			  <div className={styles.sslInputContainer}>
				  <div className={styles.tooltipAndSSLInput}>
					  <Tooltip wider={true}>
						  {__t('въведете-домейна-който-ще-бъде-защитен-с-GDPR-проb0961f')}
						  <br/>
						  {__t('Например:')}
						  <br/><br/>
						  <ul className={styles.sslList}>
							  <li>{__t('въвеждате домейна без www: mydomain.com')}</li>
							  <li>{__t('защитата ще е активна за поддомейните:')}</li>
							  <li>{__t('www.mydomain.com')}</li>
							  <li>{__t('blog.mydomain.com')}</li>
							  <li>{__t('help.mydomain.com')}</li>
						  </ul>
						  <br/><br/>
						  {__t('услугата-активирана-за-поддомейн-важи-само-за-дад28f5f1')}
					  </Tooltip>
					  <TextBox
						value={value}
						name={'domain_name'}
						placeholder={'mydomain.com'}
						error={!!showError === true ? __t('Моля, въведете домейн!') : ''}
						onChange={({target}) => setValue(target.value)}/>
				  </div>
				  <div className={styles.buttonContainer}>
					  <Button onClick={() => setDomainName(lineId, value)} value={__t('Запази')}/>
				  </div>
			  </div>
		  </div>
	  </div>
	)
}

CartLineGDPRProtect.propTypes = {
	data: PropTypes.shape({
		id: PropTypes.string.isRequired,
		serviceId: PropTypes.string.isRequired,
		serviceTypeName: PropTypes.string.isRequired,
		serviceName: PropTypes.string.isRequired,
		serviceType: PropTypes.string.isRequired,
		discountPriceList: PropTypes.number,
		discountPromo: PropTypes.number,
		discountTerm: PropTypes.number,
		term: PropTypes.string,
		oldPrice: PropTypes.string,
		price: PropTypes.string,
		priceOrig: PropTypes.string,
		currency: PropTypes.string,
		isNewService: PropTypes.bool,
		isRenewService: PropTypes.bool,
		canDelete: PropTypes.bool,
	}),
	removeService: PropTypes.func.isRequired,
	showAsPage: PropTypes.bool,
	childServices: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
		quantity: PropTypes.string,
		serviceType: PropTypes.string,
		currency: PropTypes.string,
		price: PropTypes.string,
	})]),
};

export default CartLineGDPRProtect;